import Vue from "vue";
import VueRouter from "vue-router";
import LadingPage from "@/views/LadingPage";
import Home from "@/views/Home";
import Auth from "@/auth/Auth";
import Questionario from "@/views/Questionario";
import Dispositivos from "@/views/Dispositivos";
/* import NPSWeb from '@/views/NPS' */
import Upload from "@/views/Upload";
import Estoque from "@/views/Estoque";
import ResponderQuestionario from "@/views/Pages/ResponderQuestionario.vue";
import ResponderModerno from "@/views/Pages/ResponderModerno.vue";
import Empresas from "@/views/Empresas";
import Planos from "@/views/Planos";
import Usuarios from "@/views/Usuarios";
import Respostas from "@/views/Respostas";
import Totem from "@/views/Pages/Totem.vue";
import Pesquisa from "@/views/Pages/Pesquisa";
import Avaliacoes from "@/views/Avaliacoes";
import Auditoria from "@/views/Auditoria";
import Votacao from "@/views/Pages/Votacao";
import Resultados from "@/views/Pages/Resultados";
import LinksLaureano from "@/views/Pages/LinksLaureano";
import LinksUnifit from "@/views/Pages/LinksUnifit";
import Contratar from "@/views/Pages/Contratar";
import { userKey } from "@/global";

Vue.use(VueRouter);

const routes = [
  {
    name: "LadingPage",
    path: "/",
    component: LadingPage,
    meta: { requiresAdmin: false }
  },
  {
    name: "home",
    path: "/home",
    component: Home,
    meta: {
      requiresAdmin: true,
      title: "Dashboard NPS",
      subtitle: "Acompanhe o NPS, métricas e evolução das pesquisas"
    }
  },
  { name: "auth", path: "/login", component: Auth, meta: { requiresAdmin: false } },
  {
    name: "pesquisas",
    path: "/pesquisas",
    component: Questionario,
    meta: {
      requiresAdmin: true,
      title: "Pesquisas NPS",
      subtitle: "Gerencie as pesquisas e perguntas"
    }
  },
  {
    name: "dispositivos",
    path: "/dispositivos",
    component: Dispositivos,
    meta: {
      requiresAdmin: true,
      title: "Dispositivos",
      subtitle: "Cadastro de dispositivos e associação de pesquisas"
    }
  },
  {
    name: "upload",
    path: "/upload",
    component: Upload,
    meta: { requiresAdmin: true }
  },
  {
    name: "estoque",
    path: "/estoque",
    component: Estoque,
    meta: { requiresAdmin: true }
  },
  {
    name: "questionarios",
    path: "/questionarios",
    component: ResponderQuestionario,
    meta: { requiresAdmin: false }
  },
  {
    name: "questionariosModerno",
    path: "/questionarios-moderno",
    component: ResponderModerno,
    meta: { requiresAdmin: false }
  },
  {
    name: "empresas",
    path: "/empresas",
    component: Empresas,
    meta: {
      requiresAdmin: true,
      title: "Empresas",
      subtitle: "Cadastro e configuração das empresas"
    }
  },
  {
    name: "planos",
    path: "/planos",
    component: Planos,
    meta: {
      requiresAdmin: true,
      somenteAdmin: true,
      title: "Planos",
      subtitle: "Cadastro dos planos de contratação"
    }
  },
  {
    name: "usuarios",
    path: "/usuarios",
    component: Usuarios,
    meta: {
      requiresAdmin: true,
      title: "Usuários",
      subtitle: "Gerencie seus usuários"
    }
  },
  {
    name: "respostas",
    path: "/respostas",
    component: Respostas,
    meta: {
      requiresAdmin: true,
      title: "Respostas",
      subtitle: "Consulte e exporte as respostas das pesquisas"
    }
  },
  {
    name: "totem",
    path: "/totem",
    component: Totem,
    meta: { requiresAdmin: false }
  },
  {
    name: "votacao",
    path: "/votacao",
    component: Votacao,
    meta: { requiresAdmin: false }
  },
  {
    name: "resultados",
    path: "/resultados",
    component: Resultados,
    meta: { requiresAdmin: false }
  },
  {
    name: "pesquisa",
    path: "/pesquisa",
    component: Pesquisa,
    meta: { requiresAdmin: false }
  },
  {
    name: "avaliacoes",
    path: "/avaliacoes",
    component: Avaliacoes,
    meta: {
      requiresAdmin: true,
      title: "Avaliações",
      subtitle: "Média por profissional e detalhamento das avaliações"
    }
  },
  {
    name: "auditoria",
    path: "/auditoria",
    component: Auditoria,
    meta: {
      requiresAdmin: true,
      somenteAdmin: true,
      title: "Auditoria",
      subtitle: "Histórico de alterações e registros do sistema"
    }
  },
  {
    name: "hnl",
    path: "/hnl",
    component: LinksLaureano,
    meta: { requiresAdmin: false }
  },
  {
    name: "unifit",
    path: "/unifit",
    component: LinksUnifit,
    meta: { requiresAdmin: false }
  },
  {
    name: "contratar",
    path: "/contratar/:planoSlug?",
    component: Contratar,
    meta: { requiresAdmin: false }
  }
  // { name: 'nps', path: '/nps', component: NPSWeb,},
];

const router = new VueRouter({
  routes,
  mode: "history"
});

// Controla segurança de rotas
router.beforeEach((to, from, next) => {
  const json = sessionStorage.getItem(userKey);
  const user = json ? JSON.parse(json) : null;

  if (to.matched.some(record => record.meta.somenteAdmin)) {
    if (user === "ADMIN") next();
    else next({ path: "/home" });
  } else if (to.matched.some(record => record.meta.requiresAdmin)) {
    if (
      user === "GERENTE" ||
      user === "ADMIN" ||
      user === "FORNECEDOR" ||
      user === "SUPERVISOR"
    )
      next();
    else next({ path: "/login" });
  } else {
    next();
  }
});

export default router;
